import { Parser } from "@siteimprove/alfa-parser";
import { CustomIdent, Keyword, List, } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
const { either } = Parser;
const illegalCustomIdents = [
    "will-change",
    "auto",
    "scroll-position",
    "contents",
];
const animatableFeature = either(Keyword.parse("scroll-position", "contents"), CustomIdent.parse((ident) => !illegalCustomIdents.includes(ident)));
const parse = either(Keyword.parse("auto"), List.parseCommaSeparated(animatableFeature));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/will-change}
 *
 * @internal
 */
export default Longhand.of(Keyword.of("auto"), parse, (value) => value);
//# sourceMappingURL=will-change.js.map